import { useEffect } from 'react'

import i18n from 'src/locales/i18n'

export const PDF_READY_CLASS = 'bp-pdf-ready' // DO NOT CHANGE THIS UNLESS YOU ALSO CHANGE THE PDF GENERATOR
export const PDF_VIEWER_ID = 'pdf-viewer-loading'
export const PDF_SUCCESS_CLASS = 'pdf-success'
export const PDF_ERROR_CLASS = 'pdf-error'

const hasTranslations = (data) => {
  return Object.values(data).every((v) => {
    return Object.values(v).every((fileLoaded) => fileLoaded)
  })
}

const translationsReadyPromise = () => {
  return new Promise<true>((resolve) => {
    if (i18n.isInitialized) resolve(true)

    i18n.on('loaded', (loaded) => {
      if (hasTranslations(loaded)) {
        resolve(true)
      }
    })
  })
}

const imagesReadyPromise = () => {
  return new Promise<true>((resolve) => {
    const checkForImagesLoaded = () => {
      const isReady = Array.from(document.images).every((i) => i.complete)

      if (isReady) {
        resolve(true)
      } else {
        requestAnimationFrame(checkForImagesLoaded)
      }
    }

    checkForImagesLoaded()
  })
}

const checkForPDFsLoaded = () => {
  const startCount = document.getElementsByClassName(PDF_VIEWER_ID).length
  const successCount = document.getElementsByClassName(PDF_SUCCESS_CLASS).length
  const errorCount = document.getElementsByClassName(PDF_ERROR_CLASS).length

  // No PDFs being loaded
  if (startCount === 0) {
    return true
  }

  // All PDFs have either succeeded or failed
  return startCount === successCount + errorCount
}

const pdfsReadyPromise = () => {
  return new Promise<true>((resolve) => {
    const checkStatus = () => {
      const isReady = checkForPDFsLoaded()

      if (isReady) {
        console.log('PDF docs ready')
        resolve(true)
      } else {
        requestAnimationFrame(checkStatus)
      }
    }

    checkStatus()
  })
}

type PdfReadyProps = {
  children: React.ReactNode
}

export const PdfReadyWrapper: React.FC<PdfReadyProps> = ({ children }) => {
  useEffect(() => {
    Promise.all([
      translationsReadyPromise(),
      imagesReadyPromise(),
      pdfsReadyPromise(),
    ]).then(() => {
      console.log('PDFs ready')
      document.body.classList.add(PDF_READY_CLASS)
    })
  }, [])

  return children
}
